export const environment = {
  production: false,
  useMockApi: true,
  apiBaseUrl: 'http://localhost:8000/api',
  calendarioAnidUrlOficial: '',
  mesaAyudaPostulacionesUrl: '',
};
